import { render } from "./ProjectAdDocumentListView.vue?vue&type=template&id=177c73a2&ts=true"
import script from "./ProjectAdDocumentListView.vue?vue&type=script&lang=ts"
export * from "./ProjectAdDocumentListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__